import { useState, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { UrlApi } from "../../UrlApi/UrlApi";
import {
  AlertWarning,
  AlertError,
  AlertSuccess,
} from "../../Components/AlertDialog/AlertDialog";
import Loading from "../../Components/Loading/Loading";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { ButtonOther, ButtonClose } from "../../Components/Button/Button";
import { TextInput } from "../../Components/Input/Input";
import { InputAdornment, IconButton } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { path } from "../../UrlApi/UrlApi";
import ReCAPTCHA from "react-google-recaptcha";
import { sitekey } from "../../UrlApi/UrlApi";
import Logo from '../../Assets/Images/logo.jpg';



const theme = createTheme();

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [errEmail, setErrEmail] = useState(false);
  const [errPassword, setErrPassword] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [verify, setVerify] = useState(false);
  const [verifySendMail, setVerifySendMail] = useState(false);
  const captchaRef = useRef(null);
  const captchaSendMail = useRef(null);


  const [email, setEmail] = useState("");
  // const [countLogin, setCountLogin] = useState(0);
  // const [lastPasswordChangeDate, setLastPasswordChangeDate] = useState(0);
  // const [lastLogin, setLastLogin] = useState(0);
  // const [accountActive, setAccountActive] = useState(true);

  const onSubmit = async (event) => {
    event.preventDefault();
    const token = "";
    // captchaRef.current.reset();
    // setVerify(true);
    const data = new FormData(event.currentTarget);
    const user_name = data.get("email");
    const password = data.get("password");

    if (user_name === "") {
      setErrEmail(true);
      return false;
    }

    if (password === "") {
      setErrPassword(true);
      return false;
    }
    setLoading(true);
    const ipAddress = await axios.get("https://api.ipify.org?format=json");
    const officeIP = '223.206.132.35'
    const dgfIP = '183.88.237.121';
    try {
      const check = await axios.post(UrlApi + "checklogin", { user_name, token, ip_address: ipAddress.data.ip });
      const countLogin = check.data[0].count_login;
      const accountActive = check.data[0].status_active;
      const lastPasswordChangeDate = check.data[0].count_day_last_password;
      const lastLogin = check.data[0].count_day_last_login;
      if (dgfIP !== ipAddress.data.ip) {
        AlertWarning("IP ของท่านไม่ได้รับอนุญาติ");
        setLoading(false);
        return;
      }
      else if (accountActive === false) {
        AlertWarning("บัญชีของคุณถูกระงับ  กรุณาติดต่อแอดมิน");
        setLoading(false);
        return;
      }
      else if (parseInt(lastPasswordChangeDate) >= 90) {
        AlertWarning("บัญชันี้ไม่มีการอัพเดตรหัาผ่าน 90 วัน กรุณาสร้างรหัสผ่านใหม่");
        setLoading(false);
        return;
      } else if (parseInt(countLogin) + 1 >= 4 && accountActive === false) {
        AlertWarning("บัญชีของคุณถูกระงับ กรุณาติดต่อแอดมิน");
        setLoading(false);
        return;
      } else if (parseInt(lastLogin) >= 90) {
        AlertWarning("บัญชันี้ไม่มีการเข้าใช้งาน 90 วัน กรุณาติดต่อเจ้าหน้าเพื่อขอเปิดใช้งาน");
        setLoading(false);
        return;
      }
      else {
        const res = await axios.post(UrlApi + "login", { user_name, password, token, ip_address: ipAddress.data.ip });
        if (res.data.status === 1) {
          setLoading(false);
          localStorage.setItem("token", res.data.access_token);
          localStorage.setItem("ip_address", ipAddress.data.ip);
          localStorage.setItem("user_name", data.get("email"));
          // await TestgenerateToken();
          window.location.replace(path + '/otp');
          return;
        } else {
          setLoading(false);
          AlertWarning(res.data.message);
          return;
        }
      }

      // if (ipAddress.data.ip === officeIP || ipAddress.data.ip === '171.7.61.205' || ipAddress.data.ip === '171.7.37.152') {
      //   if (accountActive === false) {
      //     AlertWarning("บัญชีของคุณถูกระงับ  กรุณาติดต่อแอดมิน");
      //     setLoading(false);
      //     return;
      //   }
      //   else if (parseInt(lastPasswordChangeDate) >= 90) {
      //     AlertWarning("บัญชันี้ไม่มีการอัพเดตรหัาผ่าน 90 วัน กรุณาสร้างรหัสผ่านใหม่");
      //     setLoading(false);
      //     return;
      //   } else if (parseInt(countLogin) + 1 >= 4 && accountActive === false) {
      //     AlertWarning("บัญชีของคุณถูกระงับ กรุณาติดต่อแอดมิน");
      //     setLoading(false);
      //     return;
      //   } else if (parseInt(lastLogin) >= 90) {
      //     AlertWarning("บัญชันี้ไม่มีการเข้าใช้งาน 90 วัน กรุณาติดต่อเจ้าหน้าเพื่อขอเปิดใช้งาน");
      //     setLoading(false);
      //     return;
      //   }
      //   else {
      //     const res = await axios.post(UrlApi + "login", { user_name, password, token, ip_address: ipAddress.data.ip });
      //     if (res.data.status === 1) {
      //       setLoading(false);
      //       localStorage.setItem("token", res.data.access_token);
      //       localStorage.setItem("ip_address", ipAddress.data.ip);
      //       localStorage.setItem("user_name", data.get("email"));
      //       // await TestgenerateToken();
      //       window.location.replace(path + '/otp');
      //       return;
      //     } else {
      //       setLoading(false);
      //       AlertWarning(res.data.message);
      //       return;
      //     }
      //   }
      // } else {
      //   AlertWarning("การล็อกอินไม่ได้รับอนุญาตจากที่อื่น");
      //   setLoading(false);
      //   return;
      // }


    } catch (err) {
      setLoading(false);
      AlertError(err);
    }
  };




  const sendMailforgotPassword = async (event) => {
    event.preventDefault();
    if (!isValidEmail(email)) {
      setEmailErr(true);
      return false;
    } else {
      setEmailErr(false);
    }

    const token = '';
    // const token = captchaSendMail.current.getValue();
    // captchaSendMail.current.reset();
    // setVerifySendMail(true);

    const body = {
      email,
      token,
    };
    setLoading(true);
    await axios
      .post(UrlApi + "forgot_password", body)
      .then((res) => {
        if (res.data.status === 1) {
          setOpenDialog(false);
          AlertSuccess(res.data.message);
          setLoading(false);
        } else {
          setOpenDialog(false);
          AlertWarning(res.data.message);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  };


  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const dialogForgotPassword = () => {
    return (
      <>
        <Dialog
          open={openDialog}
          maxWidth="1500"
          PaperProps={{ style: { borderRadius: 10, width: "50rem" } }}
        >
          <Box component="form" noValidate onSubmit={sendMailforgotPassword}>
            <DialogTitle>
              <label style={{ marginLeft: "10px" }}>ลืมรหัสผ่าน</label>
            </DialogTitle>
            <DialogContent dividers="paper">
              <table style={{ width: "100%" }}>
                <tr>
                  <td>
                    {
                      <TextInput
                        value={email}
                        placeholder="กรอก Email"
                        onChange={(e) => {
                          setEmail(e.target.value);
                          if (!isValidEmail(e.target.value)) {
                            setEmailErr(false);
                          }
                        }}
                        error={emailErr}
                        helperText={emailErr && "รูปแบบ Email ไม่ถูกต้อง"}
                        onKeyDown={() => { }}
                        width="100%"
                        height={50}
                      />
                    }
                  </td>
                </tr>
              </table>
            </DialogContent>
            <DialogActions>
              {/* <ReCAPTCHA
                sitekey={sitekey}
                onChange={(value) => {
                  setVerifySendMail(false);
                }}
                ref={captchaSendMail}
              /> */}
              <ButtonOther
                type="submit"
                message="ยืนยัน"
                disabled={verifySendMail}
                background={verifySendMail && "gray"}
              />
              <ButtonClose onClick={() => setOpenDialog(false)} />
            </DialogActions>
            <Loading open={loading} />
          </Box>
        </Dialog>
      </>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${Logo})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in V 1.2
            </Typography>
            <Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                error={errEmail}
                onChange={() => setErrEmail(false)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                error={errPassword}
                onChange={() => setErrPassword(false)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                disabled={verify}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, background: "#1676FC" }}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link
                    style={{ fontSize: "16px", justifyContent: 'flex-start' }}
                    href="#"
                    onClick={() => {
                      setOpenDialog(true);
                      setEmailErr(false);
                    }}
                  >
                    ลืมรหัสผ่าน?
                  </Link>
                  {/* <ReCAPTCHA
                    sitekey={sitekey}
                    onChange={(value) => {
                      setVerify(false);
                    }}
                    ref={captchaRef}
                  /> */}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
      {dialogForgotPassword()}
      {<Loading open={loading} />}
    </ThemeProvider>
  );
}
